<template>
    <div class="appointments-record">
        <div v-if="title"
             class="appointments-record__header">
            {{ title }}
        </div>

        <div class="appointments-record__main">
            <div class="appointments-record__project">
                <div class="appointments-record__project-data">
                    <div v-if="!projectData.link && projectData.name">
                        {{ projectData.name }}
                    </div>
                    <STBaseButton v-else
                                  :text="projectData.name"
                                  :href="projectData.link || null"
                                  :blank="Boolean(projectData.link)"
                                  modify="button_theme_reset button_font_weight-medium" />

                    <div v-if="projectData.address"
                         class="appointments-record__text is-full">
                        {{ projectData.address }}
                    </div>
                </div>
                <div class="appointments-record__description">
                    Объект <template v-if="projectData.address">
                        и адрес
                    </template>
                </div>
            </div>
            <div class="appointments-record__client">
                <div v-if="prettyPhone"
                     class="appointments-record__text">
                    {{ prettyPhone }}
                </div>
                <!--                <div v-if="clientName"-->
                <!--                     class="appointments-record__dot">-->
                <!--                    •-->
                <!--                </div>-->
                <!--                <div v-if="clientName"-->
                <!--                     class="appointments-record__text">-->
                <!--                    {{ clientName }} {{ clientSurname }}-->
                <!--                </div>-->
                <div v-if="comment"
                     class="appointments-record__text is-full">
                    {{ comment }}
                </div>

                <div class="appointments-record__description is-full">
                    Данные клиента
                </div>
            </div>
        </div>

        <div v-if="visitRecordId"
             class="appointments-record__footer">
            <STBaseButton text="Отмена"
                          icon-before="IconCloseSmall"
                          icon-after-modify="icon-fill icon_color_blue"
                          modify="button_theme_white button_size_small"
                          @click="attemptToCancelRecord" />

            <STBaseButton text="Перенести"
                          modify="button_size_small"
                          @click="changeRecord" />
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'AppointmentsRecord',

    props: {
        /*
        * interface for projectData = {
        *   name: String,
        *   address: String,
        *   link: string
        * }
        * */
        projectData  : Object,
        visitRecordId: String,
        visitStart   : String,
        phone        : String,
        clientName   : String,
        clientSurname: String,
        comment      : String
    },

    computed: {
        title() {
            const sorry = 'К сожалению, не удалось получить дату визита';
            if (!this.visitStart) {
                return sorry;
            }

            const [date, time] = this.visitStart.split(' ');

            if (!date && !time) {
                return sorry;
            }

            if (!date) {
                return `В ${time}`;
            }

            if (!time) {
                return `${moment(date).locale('ru').format('DD MMMM YYYY')}}`;
            }

            return `${moment(date).locale('ru').format('DD MMMM YYYY')} в ${time}`;
        },

        prettyPhone() {
            if (!this.phone?.length) {
                return '';
            }

            return `+7 (${this.phone.slice(1, 4)}) ${this.phone.slice(4, 7)}-${this.phone.slice(7, 9)}-${this.phone.slice(9)}`;
        }
    },

    methods: {
        attemptToCancelRecord() {
            this.$emit('attemptToCancelRecord', this.visitRecordId);
        },

        changeRecord() {
            let changingTitle = `${this.title}`;

            if (this.projectData?.name || this.projectData?.address) {
                changingTitle += ' • ';
            }

            if (this.projectData?.name && this.projectData?.address) {
                changingTitle += `${this.projectData.name}, ${this.projectData.address}`;
            } else if (this.projectData?.name) {
                changingTitle += this.projectData.name;
            } else if (this.projectData?.address) {
                changingTitle += this.projectData.address;
            }

            this.$emit('changeRecord', this.visitRecordId, changingTitle);
        }
    }
};
</script>

<style scoped lang="scss">
@import "AppointmentsRecord";
</style>
